import { Component, OnInit, OnDestroy } from '@angular/core';
import { FinanceService } from '../../../services/finance.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionLike as ISubscription } from 'rxjs';

declare var moment: any;

@Component({
    selector: 'app-finance-collection',
    templateUrl: './finance-collection.component.html',
    styleUrls: ['./finance-collection.component.scss']
})
export class FinanceCollectionComponent implements OnInit, OnDestroy {
    loading: boolean = true;

    querySubscriber: ISubscription;
    dataSubscriber: ISubscription;

    tableData;
    total: any = null;

    startData = {};

    filters = {};

    queryString: string = '';

    selects: any = {
        statuses: [],
        gateways: [],
        sources: []
    };

    promises = [];

    calendarDates = {
        startDate: moment()
            .startOf('month')
            .format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    };

    item = null;

    constructor(
        private activatedRoute: ActivatedRoute,
        private financeService: FinanceService,
        private router: Router,
        private modalService: NgbModal
    ) {}

    ngOnInit() {
        this.getGateways();
        this.getSourcers();
        this.getStatuses();
        Promise.all(this.promises).then();

        this.querySubscriber = this.activatedRoute.queryParams.subscribe(queryParams => {
            this.startData = {
                created_at_start: this.calendarDates.startDate,
                created_at_end: this.calendarDates.endDate,
                loan_code_str: '',
                activation_date_start: '',
                activation_date_end: '',
                status_id: '',
                amount: '',
                provider_id: '',
                source_id: '',
                personalid: '',
                full_name: ''
            };

            if (this.dataSubscriber) {
                this.dataSubscriber.unsubscribe();
            }

            // Set Init Filters
            this.setInitFilters(queryParams);
            // Create Query String
            this.createQueryString(this.filters);

            this.getTableData();
        });
    }

    ngOnDestroy() {
        this.querySubscriber.unsubscribe();
        this.dataSubscriber.unsubscribe();
    }

    getTableData() {
        this.loading = true;
        this.dataSubscriber = this.financeService.getCollection(this.queryString).subscribe(response => {
            if (response) {
                this.tableData = response;
                this.loading = false;
            }
        });
    }

    getDataOnFilterSubmit() {
        // Set Init Filters
        this.filters = { ...this.filters, page: 0 };

        // Create Query String
        this.createQueryString(this.filters);

        // Push Query String to history.
        // Navigates without replacing the current state in history.
        this.pushFiltersToHistory(this.filters);
    }

    createQueryString(filters = {}) {
        const clearFilters = { ...filters };

        Object.keys(clearFilters).forEach(
            key => (!clearFilters[key] || clearFilters[key] === 'empty') && delete clearFilters[key]
        );

        this.queryString = Object.keys(clearFilters)
            .map(key => key + '=' + clearFilters[key])
            .join('&');
    }

    pushFiltersToHistory(filters, replaceUrl = false) {
        Object.keys(filters).forEach(key => !filters[key] && delete filters[key]);

        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: Object.keys(filters).length > 0 ? filters : {},
            replaceUrl: replaceUrl
        });
    }

    setInitFilters(query = {}) {
        this.filters = { ...this.startData, ...query };
    }

    getDataOnPageChange(page) {
        this.filters['page'] = page;

        // Create Query String
        this.createQueryString(this.filters);

        // Push Query String to history.
        // Navigates without replacing the current state in history.
        this.pushFiltersToHistory(this.filters);
    }

    onChangeDate(e: any) {
        this.filters = { ...this.filters, ...e, page: 0 };
        // Create Query String
        this.createQueryString(this.filters);

        // Push Query String to history.
        // Navigates without replacing the current state in history.
        this.pushFiltersToHistory(this.filters);
    }

    goto(lead_id) {
        if (lead_id) {
            this.router.navigate([`/backoffice/loans/overview/${lead_id}/loanInfo/`, lead_id]);
        }
    }

    openPayment(payment, item) {
        this.financeService
            .getPaymentDetail(item.id)
            .toPromise()
            .then(response => {
                if (response) {
                    this.item = { ...item, ...response };
                    console.log(this.item);
                    this.modalService.open(payment, { size: 'lg' });
                }
            });
    }

    getStatuses() {
        this.promises.push(
            this.financeService
                .getStatuses()
                .toPromise()
                .then(response => {
                    if (response.length) {
                        this.selects.statuses = response;
                    }
                })
        );
    }

    getGateways() {
        this.promises.push(
            this.financeService
                .getGateways()
                .toPromise()
                .then(response => {
                    if (response.length) {
                        this.selects.gateways = response;
                    }
                })
        );
    }

    getSourcers() {
        this.promises.push(
            this.financeService
                .getSources()
                .toPromise()
                .then(response => {
                    if (response.length) {
                        this.selects.sources = response;
                    }
                })
        );
    }
}
